import { useTranslation } from 'react-i18next'

import { Box, Button, Stack } from '@mui/material'

import { Carousel } from '@pages/LandingPage/components/Carousel'

import { TLGTypography } from '@components/TLGTypography'

import { carouselItemSx, containerSx, itemImageSx } from './styles'

export interface ICarouselItem {
  image: {
    name: string
    src: string
  }
  link?: string
}

const SIZE_OF_ITEMS_PER_WINDOW_BREAKPOINT_IN_PX = {
  xs: 130,
  md: 155,
  lg: 180,
  xl: 190,
  xxl: 190,
}

const IT_CUSTOMERS_CAROUSEL_ITEMS: ICarouselItem[] = [
  {
    image: {
      name: 'Microsoft',
      src: '/images/landing-pages/our-client/microsoft.webp',
    },
  },
  {
    image: {
      name: 'NVIDIA',
      src: '/images/landing-pages/our-client/nvidia.webp',
    },
  },
  {
    image: {
      name: 'IBM',
      src: '/images/landing-pages/our-client/ibm.webp',
    },
  },
  {
    image: {
      name: 'Apple',
      src: '/images/landing-pages/our-client/apple.webp',
    },
  },
  {
    image: {
      name: 'HP',
      src: '/images/landing-pages/our-client/hp.webp',
    },
  },
  {
    image: {
      name: 'Dell',
      src: '/images/landing-pages/our-client/dell.webp',
    },
  },
  {
    image: {
      name: 'Lumen',
      src: '/images/landing-pages/our-client/lumen.webp',
    },
  },
  {
    image: {
      name: 'Pax8',
      src: '/images/landing-pages/our-client/pax8.webp',
    },
  },
  {
    image: {
      name: 'Okta',
      src: '/images/landing-pages/our-client/okta.webp',
    },
  },
  {
    image: {
      name: 'TD SYNNEX',
      src: '/images/landing-pages/our-client/td-synnex.webp',
    },
  },
  {
    image: {
      name: 'Red River',
      src: '/images/landing-pages/our-client/red-river.webp',
    },
  },
  {
    image: {
      name: 'Envista',
      src: '/images/landing-pages/our-client/envista.webp',
    },
  },
  {
    image: {
      name: 'Advizex',
      src: '/images/landing-pages/our-client/advizex.webp',
    },
  },
  {
    image: {
      name: 'Comport',
      src: '/images/landing-pages/our-client/comport.webp',
    },
  },
  {
    image: {
      name: 'Clock Spring',
      src: '/images/landing-pages/our-client/clock-spring.webp',
    },
  },
  {
    image: {
      name: 'Intrusion',
      src: '/images/landing-pages/our-client/intrusion.webp',
    },
  },
]

const OurClientsSection = () => {
  const { t } = useTranslation()

  return (
    <Stack
      data-testid="tech-vendors-benefits-our-it-customers-section"
      sx={containerSx}
    >
      <TLGTypography responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}>
        {t('Some of our clients')}:
      </TLGTypography>

      <Carousel
        id="our-clients-carousel"
        dontCenterWhenFewerItems
        items={IT_CUSTOMERS_CAROUSEL_ITEMS}
        numberOfItemsPerPage={{
          dynamic: true,
          size: SIZE_OF_ITEMS_PER_WINDOW_BREAKPOINT_IN_PX,
        }}
        renderItem={({ image, link }, key) => (
          <Button
            key={key}
            data-testid="carousel-item"
            component="a"
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            sx={carouselItemSx({
              pointerCursor: !!link,
              addPadding: true,
            })}
          >
            <Box
              alt={image.name}
              title={image.name}
              loading="lazy"
              component="img"
              src={image.src}
              sx={itemImageSx}
            />
          </Button>
        )}
      />
    </Stack>
  )
}

export { OurClientsSection }
